import React, { useEffect, useState } from 'react'
import { FaVideoSlash } from 'react-icons/fa'
import './KabaddiCartoons.scss'
import KabaddiTeamScores from '../components/KabaddiTeamScores'

const Clip = ({ clip, overlayText, layout, gameType, fullscreenCartoon }) => {
    const [clips, setClips] = useState([])
    const [activeClipName, setActiveClipName] = useState(null)

    const videoRef = React.useRef(null)

    useEffect(() => {
        let clipsSplit = clip.split(', ')
        setClips(clipsSplit)
        setActiveClipName(clipsSplit[0])
    }, [clip])

    useEffect(() => {
        const videoPlayer = videoRef.current
        videoPlayer.loop = false

        function playNextClip(e) {
            const currentClipIndex = clips.findIndex(name => name === activeClipName)
            const newClipIndex = currentClipIndex + 1

            if (clips[newClipIndex]) {
                setActiveClipName(clips[newClipIndex])
                videoPlayer.play()
            } else {
                videoPlayer.pause()
            }
        }

        videoPlayer.addEventListener('ended', playNextClip)

        return () => {
            videoPlayer.removeEventListener('ended', playNextClip)
        }
    }, [clips, activeClipName])

    const showOverlay = videoRef.current && 
        (videoRef.current.src.includes('crowd') || videoRef.current.src.includes('endgame'))

    let videoLocationURL = 'https://quantumcricketleague.com/vid/'

    if (gameType === 'KABD' || gameType === 'VRKBD') {
        videoLocationURL = 'https://videos.decimalcricket.net/VRKBD/'
    }

    return (
        <>
            <div className="overlay">
                { showOverlay && 
                    <div className="text">
                        {overlayText}
                    </div>
                }
            </div>
            <video 
                src={`${videoLocationURL}${activeClipName}.mp4`} 
                playsInline={true}
                webkit-playsinline="true"
                muted={true} // Chrome does not allow autoplay with sound
                autoPlay={true}
                width="100%"
                type="video/mp4"
                ref={videoRef}
                style={{ 
                    maxHeight: layout === 'single' && ! fullscreenCartoon ? '210px' : null,
                    paddingBottom: gameType === 'QUANTUM' ? '15px' : null, 
                 }}
            />
        </>
    )
}

export default function Cartoons({ clip, layout, teams, scoreboard, backgroundColor, foregroundColor, gameType, commentary, fullscreenCartoon }) {

    const [latestCommentary, setLatestCommentary] = useState('')

    useEffect(() => {
        if (clip && clip.includes('P5')) {
            let com = null
            if (commentary && commentary.commentaries && commentary.commentaries.inns1) {
                com = commentary.commentaries.inns1[commentary.commentaries.inns1.length-1]
                if (com) {
                    setLatestCommentary(com.commentary)
                }
            }
        } else if (clip && clip.includes('P1')) {
            setLatestCommentary(null)
        }
    }, [clip, commentary])    

    function getValueFromScoreboard(name) {
        if (!scoreboard) {
            return null
        }

        const found = scoreboard.find(i => i.name === name)

        if (found){
            return found.value
        }

        return null
    }

    const status = getValueFromScoreboard('Status')
    const teamAPoints = getValueFromScoreboard('TeamA Points')
    const teamBPoints = getValueFromScoreboard('TeamB Points')
    const teamAName = getValueFromScoreboard('TeamA')
    const teamBName = getValueFromScoreboard('TeamB')

    let winMessage = null

    if (status === 'Event Closed') {
        if (teamAPoints > teamBPoints) {
            winMessage = `${teamAName} Win!`
        } else if (teamBPoints > teamAPoints) {
            winMessage = `${teamBName} Win!`
        } else {
            winMessage = "Match Tied"
        }
    }

    return (
        <div className="kabaddi-cartoons" style={{ 
            backgroundColor, 
            display: layout === 'double' ? 'flex' : 'block',
         }}>
            { ! fullscreenCartoon && <KabaddiTeamScores teams={teams} scoreboard={scoreboard} showClock={true}/> }
            { clip ? ( 
                <div 
                    className="video-wrapper"
                    style={{
                        display: layout === 'double' ? 'flex' : 'block'
                    }}
                >
                    <Clip 
                        clip={clip} 
                        layout={layout} 
                        gameType={gameType}
                        fullscreenCartoon={fullscreenCartoon}
                    />
                </div>
            ) : (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', color: 'white'}}>
                    <div style={{ textAlign: 'center'}}>
                        <FaVideoSlash size={25}/>
                        <div>No video clip</div>
                    </div>
                </div>
            )}
            { (latestCommentary || winMessage) && 
                <div className="commentary" style={{ 
                    backgroundColor: foregroundColor, 
                    color: backgroundColor 
                }}>{winMessage ? winMessage : latestCommentary}</div>
            }
        </div>
    )
}
